module.exports = __webpack_public_path__ + "static/media/btn_point_back_nor.0241e0f9.svg";